import React, { useState, useEffect } from 'react';
import * as S from './styles';
import api from '../../services/api';
import iconCalendarBlue from '../../assets/icons/icon-calendar-blue.png';
import { Loading } from '../loading';
import { theme } from '../../styles/theme';

const CalendaryCampMetric = ({ dtInicial, dtFinal, ...props }) => {
    const [totalEventos, setTotalEventos] = useState(null);

    const searchInitialData = async () => {
        setTotalEventos(null);

        try {
            const response = await api.get('/relatorio/caderno-campo', {
                params: { dtInicial, dtFinal },
            });
            setTotalEventos(response.data?.data?.total ?? 0);
        } catch (error) {
            setTotalEventos(0);
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [dtInicial, dtFinal])

    return (
        <S.Container>
            <S.IconCircle>
                <img src={iconCalendarBlue} alt="Ícone de calendário" width="18" height="18" />
            </S.IconCircle>
            <S.Content>
                <S.Title>Caderno de Campo</S.Title>

                {totalEventos === null ? (
                    <S.LoadingBox>
                        <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
                    </S.LoadingBox>
                ) : (
                    <>
                        <S.Description>
                            {`${totalEventos} evento${totalEventos === 1 ? '' : 's'} registrado${totalEventos === 1 ? '' : 's'}.`} Registrar visitas e aplicações ajuda a documentar seu histórico de campo.
                        </S.Description>
                        <S.Link href="/caderno-campo">Ver Caderno de Campo →</S.Link>
                    </>
                )}
            </S.Content>
        </S.Container>
    )
}

export default CalendaryCampMetric;
